<template>
  <div class="operation">
    <Highway v-if="asset_type === '收费公路'" :asset_name="asset_name" />
    <IndustrialPark v-else-if="asset_type === '产业园'" :_asset_name="asset_name" />
    <Logistics v-else-if="asset_type === '物流仓储'" :_asset_name="asset_name" />
    <Consumption v-else-if="asset_type === '消费'" :_asset_name="asset_name" />
    <Tenancy v-else-if="asset_type === '保障性住房'" :_asset_name="asset_name" />
    <Energy v-else-if="asset_type === '能源'" :_asset_name="asset_name" />
    <DataCenter v-else-if="asset_type === '数据中心'" :_asset_name="asset_name" />
  </div>
</template>

<script>
import Highway from './highway';
import IndustrialPark from './IndustrialPark';
import Logistics from './Logistics';
import Consumption from './consumption';
import Tenancy from './tenancy';
import Energy from './energy';
import DataCenter from './dataCenter';

export default {
  components: {
    Highway,
    IndustrialPark,
    Logistics,
    Consumption,
    Tenancy,
    Energy,
    DataCenter,
  },
  data() {
    return {
      ROOTFONTFIZE: 0,
      CODE: '',
      asset_name: [],
      asset_type: '',
    };
  },
  created() {
    this.reload();
    this.getAssetValues();
  },
  mounted() {
    this.fnGetWidth();
    window.addEventListener('resize', this.funResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.funResize);
  },
  methods: {
    async getAssetValues() {
      let code = this.CODE;

      const { data } = await this.$https.get('/api/asset_value_by_jllt_code?code=' + code);

      if (data.code !== 200) return this.$message.error(data.msg);
      const result = data.data || [];
      if (!result[0]) {
        this.$message.error('暂无运营数据');
        return;
      }
      this.asset_type = (result[0] || {})['资产类型'];
      this.asset_name = result;
      // this.asset_name = [...new Set(result.map((item) => item['资产名称']))];
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    funResize() {
      this.fnGetWidth();
    },

    fnGetWidth() {
      this.ROOTFONTFIZE = localStorage.getItem('ROOTFONTFIZE');
    },

    reload() {
      this.CODE = window.sessionStorage.getItem('CURRENTCODE');
    },
  },

  computed: {
    cssVars() {
      return {
        '--ROOTFONTFIZE': this.ROOTFONTFIZE + 'px',
      };
    },
    currentTheme() {
      return this.$store.state.theme;
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.fnGetTheme();
    },
  },
};
</script>

<style lang="less" scoped>
.operation {
}
</style>
